import useCalendarSyncFlowStore, { CAL_TYPE_SYNC } from '../../store/sync-flow/useCalendarSyncFlowStore';
import { browserHistory } from 'react-router';
import useCalendarStore from '../../store/calendar/useCalendarStore';

export const NavSteps = {
  VALUE_PROPS: 'sync-value-props',
  EXTERNAL_CAL_SELECTION: 'sync-external-cal-selection',
  SELECT_CALENDAR: 'select-calendar',
  I_CALENDAR: 'sync-i-calendar'
};

export const getCurrentStep = () => {
  const hash = window.location.hash;
  if (hash.includes(NavSteps.VALUE_PROPS)) return NavSteps.VALUE_PROPS;
  if (hash.includes(NavSteps.EXTERNAL_CAL_SELECTION)) return NavSteps.EXTERNAL_CAL_SELECTION;
  if (hash.includes(NavSteps.SELECT_CALENDAR)) return NavSteps.SELECT_CALENDAR;
  if (hash.includes(NavSteps.I_CALENDAR)) return NavSteps.I_CALENDAR;
  return null;
};

const useSyncFlowNav = () => {
  const {
    fetchCronofyLink,
    syncCronofyCalendar,
    syncICalendar,
    handleICalValidation
  } = useCalendarSyncFlowStore();
  const calendarType = useCalendarSyncFlowStore((state) => state.calendarType);
  const selectedSpaceId = useCalendarStore((state => state.selectedSpaceId));
  const spaceId = useCalendarSyncFlowStore((state) => state.spaceId);
  const selectedCronofyCalId = useCalendarSyncFlowStore((state) => state.selectedCronofyCalId);
  const isFetchingCronofyCals = useCalendarSyncFlowStore((state) => state.isFetchingCronofyCals);
  const isConnectingCal = useCalendarSyncFlowStore((state) => state.isConnectingCal);

  const navToStep = (step) => {
    browserHistory.push(`${window.location.pathname}${window.location.search}#${step}`);
  };

  const clearNav = () => {
    browserHistory.push(`${window.location.pathname}${window.location.search}`);
  };

  const currentStep = getCurrentStep();

  const navToNextStep = () => {
    if (currentStep === NavSteps.VALUE_PROPS) {
      navToStep(NavSteps.EXTERNAL_CAL_SELECTION);
    } else if (currentStep === NavSteps.EXTERNAL_CAL_SELECTION) {
      if (calendarType === CAL_TYPE_SYNC) {
        fetchCronofyLink();
      } else {
        navToStep(NavSteps.I_CALENDAR);
      }
    } else if (currentStep === NavSteps.SELECT_CALENDAR) {
      syncCronofyCalendar(selectedSpaceId);
    } else if (currentStep === NavSteps.I_CALENDAR) {
      if (!isConnectingCal && handleICalValidation()) {
        syncICalendar();
      }
    }
  };

  const navToPreviousStep = () => {
    if (currentStep === NavSteps.I_CALENDAR) {
      return navToStep(NavSteps.EXTERNAL_CAL_SELECTION);
    }
  };

  const canNav = () => {
    if (currentStep === NavSteps.EXTERNAL_CAL_SELECTION) {
      return spaceId && calendarType;
    }
    if (currentStep === NavSteps.SELECT_CALENDAR) {
      return null !== selectedCronofyCalId && !isFetchingCronofyCals;
    }
    return true;
  };

  return {
    currentStep,
    navToNextStep,
    navToPreviousStep,
    navToStep,
    canNav,
    clearNav
  };
};

export default useSyncFlowNav;
